import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { StyledEngineProvider } from '@mui/material/styles';

import { AuthProvider } from "./contexts/AuthContext"
import { ListingProvider } from './contexts/ListingContext';
import { OperatorProvider } from './contexts/OperatorContext';
import { RequestProvider } from './contexts/RequestContext';
import { OptionsProvider } from './contexts/OptionsContext';
import { BlogProvider } from './contexts/BlogContext';
import { UserProvider } from './contexts/UserContext';
import { HospitalProvider } from './contexts/HospitalContext';

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <ListingProvider>
        <OperatorProvider>
          <RequestProvider>
            <OptionsProvider>
              <BlogProvider>
                <UserProvider>
                  <HospitalProvider>
                    <StyledEngineProvider injectFirst>
                      <App />
                    </StyledEngineProvider>
                  </HospitalProvider>
                </UserProvider>
              </BlogProvider>
            </OptionsProvider>
          </RequestProvider>
        </OperatorProvider>
      </ListingProvider>
    </AuthProvider>
  </React.StrictMode >,
  document.getElementById('root')
);
